const BASE = import.meta.env.VITE_API_URL || '/v1'
const TOKEN_KEY = 'gc_admin_token'

export const getToken = () => localStorage.getItem(TOKEN_KEY)
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t)
export const clearToken = () => localStorage.removeItem(TOKEN_KEY)

export class ApiError extends Error {
  constructor(status, code, message) {
    super(message)
    this.status = status
    this.code = code
  }
}

export async function api(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' }
  const token = getToken()
  if (auth && token) headers.Authorization = `Bearer ${token}`

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  })

  if (res.status === 401) {
    clearToken()
    if (!location.pathname.startsWith('/login')) location.href = '/login'
    throw new ApiError(401, 'unauthorized', 'Oturum sonlandi')
  }

  if (res.status === 204) return null

  const json = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = json.error || {}
    throw new ApiError(res.status, err.code || 'error', err.message || 'Bir hata olustu')
  }
  return json
}
